import { render, staticRenderFns } from "./merchantAdvertisingDetail.vue?vue&type=template&id=3c19eb92&scoped=true"
import script from "./merchantAdvertisingDetail.vue?vue&type=script&lang=js"
export * from "./merchantAdvertisingDetail.vue?vue&type=script&lang=js"
import style1 from "./merchantAdvertisingDetail.vue?vue&type=style&index=1&id=3c19eb92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19eb92",
  null
  
)

export default component.exports